import { Dossier } from "@rumble-it/common-lib/types/models/Dossier.interface";
import { Claim } from "@rumble-it/common-lib/types/models/Claim.interface";
import { ClaimDossierCalculationDetails } from "../components/ClaimDossierCalculationDetails";
import { ClaimDossierCalculationSummary } from "../components/ClaimDossierCalculationSummary";
import { Button, Card } from "@rumbledirect/ui";
import { calculationColumns } from "../data/calculationsColumns";
import { useState } from "react";
import ArrowLeftOutlined from "@ant-design/icons/lib/icons/ArrowLeftOutlined";
import { Calculation } from "@rumble-it/common-lib/types/models/Calculation.interface";
import { Table } from "@/components/v2";

export const ClaimDossierCalculationTab = ({
  data,
  claim,
  setActiveTab,
}: {
  data: Dossier | undefined;
  claim: Claim | undefined | null;
  setActiveTab: (tab: string) => void;
}) => {
  const [view, setView] = useState<"summary" | "details">("summary");
  const [selectedCalculation, setSelectedCalculation] =
    useState<Calculation | null>(null);

  return (
    <>
      {view === "summary" ? (
        <Card title="Calculaties">
          <Table
            pagination={false}
            columns={calculationColumns(setView, setSelectedCalculation)}
            dataSource={claim?.calculations || []}
            rowKey="id"
          />
        </Card>
      ) : (
        <>
          <Button
            className="mb-5"
            icon={<ArrowLeftOutlined />}
            onClick={() => setView("summary")}
          >
            Terug naar calculaties
          </Button>

          <ClaimDossierCalculationSummary
            calculation={selectedCalculation}
            dossier={data}
          />

          <ClaimDossierCalculationDetails
            calculation={selectedCalculation}
            claim={claim}
            setActiveTab={setActiveTab}
          />
        </>
      )}
    </>
  );
};

export const generateSixDigitNumber = (id: string): string => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    const char = id.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  // Ensure it's always a 6-digit number (100000-999999)
  const sixDigit = (Math.abs(hash) % 900000) + 100000;
  return sixDigit.toString();
};
